import { render, staticRenderFns } from "./SuccessScreenMedtochka.vue?vue&type=template&id=904100ee&scoped=true&"
import script from "./SuccessScreenMedtochka.vue?vue&type=script&lang=ts&setup=true&"
export * from "./SuccessScreenMedtochka.vue?vue&type=script&lang=ts&setup=true&"
import style0 from "./SuccessScreenMedtochka.vue?vue&type=style&index=0&id=904100ee&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "904100ee",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/prodoctorov/pd-ssr/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('904100ee')) {
      api.createRecord('904100ee', component.options)
    } else {
      api.reload('904100ee', component.options)
    }
    module.hot.accept("./SuccessScreenMedtochka.vue?vue&type=template&id=904100ee&scoped=true&", function () {
      api.rerender('904100ee', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "www/vue_components/common/AppointmentPage/components/common/SuccessScreenMedtochka.vue"
export default component.exports